import LayoutDefault from '@/layouts/LayoutDefault.vue';

import Gudang from './gudang.route';
import Kasir from './kasir.route';
import Penjualan from './penjualan.route';
import Admin from './admin.route';

let stockistcenter = [
  {
    path: '/saldo',
    name: 'MyBalance',
    component: () => import('@/views/stockist-center/Balance.vue'),
    meta: {
      auth: true,
      title: 'Saldo Saya',
      layout: LayoutDefault,
      withoutParent: true,
    },
  },
];

stockistcenter = stockistcenter.concat(
    Admin.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Admin'
        }
    })),
    Gudang.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Gudang'
        }
    })),
    Kasir.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Kasir'
        }
    })),
    Penjualan.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Penjualan'
        }
    }))
);

export default stockistcenter;
